import { render } from "./IOS.vue?vue&type=template&id=4dcdae06&scoped=true"
import script from "./IOS.vue?vue&type=script&lang=js"
export * from "./IOS.vue?vue&type=script&lang=js"

import "./IOS.vue?vue&type=style&index=0&id=4dcdae06&scoped=true&lang=less"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcdae06"]])

export default __exports__